/**
 * Whether a failed upload may delete the photo group it created.
 *
 * Only when we created it in this run, nothing registered against it, and
 * NOTHING reached storage. Since presign records upload intents, any photo
 * that landed is registered by the server's sweep even when our own metadata
 * call failed. Deleting the group then either cascades those intents away
 * (bytes orphaned) or, if the sweep already ran, removes photos the customer
 * has -- while telling them nothing was saved, so they upload again and get
 * duplicates. An unknown count is treated as "something landed".
 */
export function shouldDeleteEmptyGroup(args: {
  createdOrderPhotoId: string | null;
  uploadAttachedPhotos: boolean;
  landedCount: number | undefined;
}): boolean {
  return (
    !!args.createdOrderPhotoId &&
    !args.uploadAttachedPhotos &&
    args.landedCount === 0
  );
}
